import { Modal } from 'react-bootstrap-v5';
import { useEffect, useState, useCallback } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Line, Doughnut, Pie, Bar } from 'react-chartjs-2';
import RelatoriosService from '../../services/RelatoriosService';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

const ModalDashboardVertical = ({ show, toggleModal, esteiraID }: { show: boolean, toggleModal: Function, esteiraID: number }) => {


    const [rows, setRows] = useState<any[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [loaded, setLoaded] = useState<boolean>(false);
    const [relatorios, setRelatorios] = useState<any[]>([]);

    useEffect(() => {

        if (!loaded && !loading) {
            setLoading(true);

            RelatoriosService.buscarDadosRelatorioVerfical(esteiraID).then((resp) => {
                setLoaded(true);
                setLoading(false);
                setRelatorios(resp);
            }).catch(() => {
                setLoading(false);
            });
        }
    }, [esteiraID, loading, loaded]);

    const somaMeses = useCallback((item: any) => {
        return Math.abs(item.janeiro) + Math.abs(item.fevereiro) + Math.abs(item.marco) + Math.abs(item.abril) + Math.abs(item.maio) + Math.abs(item.junho) + Math.abs(item.julho) + Math.abs(item.agosto) + Math.abs(item.setembro) + Math.abs(item.outubro) + Math.abs(item.novembro) + Math.abs(item.dezembro);
    }, []);

    return (
        <Modal fullscreen centered={true} show={show} onHide={toggleModal}>
            <div className="modal-content" style={{ backgroundColor: '#212529' }}>
                <div className="modal-header">
                    <h5 className="modal-title titulo-modal" style={{ textTransform: 'uppercase', color: 'white' }}>Dashboard</h5>
                    <div className="btn btn-icon btn-sm btn-active-light-primary ms-2">
                        <button onClick={() => toggleModal()} style={{ backgroundColor: 'transparent', border: 'none' }}>
                            <i className="fas fa-times" style={{ color: 'white' }}></i>
                        </button>
                    </div>
                </div>
                <div className="modal-body">
                    <div className="row" style={{ justifyContent: 'space-evenly', alignItems: 'center' }}>
                        {(relatorios.length === 0 || relatorios.filter(f => f.items.length > 0).length === 0) && !loading && (
                            <div className='col-md-12 center'>
                                <p style={{ color: 'white', fontWeight: 'bold' }}>Por favor processe os cartões para gerar informação ao dashboard.</p>
                            </div>
                        )}
                        {loading && !loaded && (
                            <div className='col-md-12 center'>
                                <div style={{ display: 'flex', flexDirection: 'column', color: 'white' }} className='mt-2'>
                                    <div className="spinner-border text-success" role="status">
                                        <span className="sr-only" style={{ color: 'white', fontWeight: 'bold' }}>Carregando...</span>
                                    </div>
                                </div>
                            </div>
                        )}
                        {relatorios.filter((f: any) => f.ativo).map((item) => (
                            <>
                                {item.tipo === 'cartao' && item.items.length > 0 && (
                                    <div className='col-md-2 mt-2' style={{ height: '100px' }}>
                                        <div className='col-md-12' style={{ padding: '10px', fontSize: '15px', backgroundColor: '#32325d', borderRadius: '10px', color: '#f6f9fc', height: '100%' }}>
                                            <div className='row' style={{ height: '100%' }}>
                                                <div className='col-md-12' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                                    <p style={{ margin: 0 }}>{item.nome}</p>
                                                    <p style={{ margin: 0 }}>{Math.abs(somaMeses(item.items[0]?.constanciaHorizontal || 0)).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {item.tipo === 'cartao-subtracao' && item.items.length > 0 && (
                                    <div className='col-md-2 mt-2' style={{ height: '100px' }}>
                                        <div className='col-md-12' style={{ padding: '10px', fontSize: '15px', backgroundColor: '#32325d', borderRadius: '10px', color: '#f6f9fc', height: '100%' }}>
                                            <div className='row' style={{ height: '100%' }}>
                                                <div className='col-md-12' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                                    <p style={{ margin: 0 }}>{item.nome}</p>
                                                    <p style={{ margin: 0 }}>{(Math.abs(somaMeses(item.items[0]?.constanciaHorizontal || 0)) - Math.abs(somaMeses(item.items[1]?.constanciaHorizontal || 0))).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {item.tipo === 'cartao-porcentagem-personalizado-receita' && item.items.length === 3 && (
                                    <div className='col-md-2 mt-2' style={{ height: '100px' }}>
                                        <div className='col-md-12' style={{ padding: '10px', fontSize: '15px', backgroundColor: '#32325d', borderRadius: '10px', color: '#f6f9fc', height: '100%' }}>
                                            <div className='row' style={{ height: '100%' }}>
                                                <div className='col-md-12' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                                    <p style={{ margin: 0 }}>{item.nome}</p>
                                                    <p style={{ margin: 0 }}>{((Math.abs(somaMeses(item.items[2]?.constanciaHorizontal || 0)) / (somaMeses(item.items[0]?.constanciaHorizontal || 0) - somaMeses(item.items[1]?.constanciaHorizontal || 0))) * 100).toFixed(2)}%</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {item.tipo === 'cartao-porcentagem-personalizado-carga' && item.items.length === 3 && (
                                    <div className='col-md-2 mt-2' style={{ height: '100px' }}>
                                        <div className='col-md-12' style={{ padding: '10px', fontSize: '15px', backgroundColor: '#32325d', borderRadius: '10px', color: '#f6f9fc', height: '100%' }}>
                                            <div className='row' style={{ height: '100%' }}>
                                                <div className='col-md-12' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                                    <p style={{ margin: 0 }}>{item.nome}</p>
                                                    <p style={{ margin: 0 }}>{(((somaMeses(item.items[0]?.constanciaHorizontal || 0) + somaMeses(item.items[1]?.constanciaHorizontal || 0)) / Math.abs(somaMeses(item.items[2]?.constanciaHorizontal || 0))) * 100).toFixed(2)}%</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {item.tipo === 'cartao-porcentagem-personalizado-folha' && item.items.length === 2 && (
                                    <div className='col-md-2 mt-2' style={{ height: '100px' }}>
                                        <div className='col-md-12' style={{ padding: '10px', fontSize: '15px', backgroundColor: '#32325d', borderRadius: '10px', color: '#f6f9fc', height: '100%' }}>
                                            <div className='row' style={{ height: '100%' }}>
                                                <div className='col-md-12' style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
                                                    <p style={{ margin: 0 }}>{item.nome}</p>
                                                    <p style={{ margin: 0 }}>{((Math.abs(somaMeses(item.items[0]?.constanciaHorizontal || 0)) / Math.abs(somaMeses(item.items[1]?.constanciaHorizontal || 0))) * 100).toFixed(2)}%</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {item.tipo === 'pizza-comum' && item.items.filter((f: any) => somaMeses(f.constanciaHorizontal) > 0).length > 0 && (
                                    <div className='col-md-4 mt-6'>
                                        <Pie

                                            data={{
                                                labels: item.items.filter((f: any) => somaMeses(f.constanciaHorizontal) > 0).map((item2: any) => item2.nome),
                                                datasets: [
                                                    {
                                                        data: item.items.filter((f: any) => somaMeses(f.constanciaHorizontal) > 0).map((item2: any) => somaMeses(item2.constanciaHorizontal)),
                                                        backgroundColor: item.items.filter((f: any) => somaMeses(f.constanciaHorizontal) > 0).map((item2: any) => item2.color),
                                                        borderColor: item.items.filter((f: any) => somaMeses(f.constanciaHorizontal) > 0).map((item2: any) => item2.color),
                                                        borderWidth: 1,
                                                    },
                                                ],
                                            }}
                                            width={100}
                                            height={200}
                                            options={{
                                                responsive: true,
                                                maintainAspectRatio: false,
                                                plugins: {
                                                    legend: {
                                                        position: 'top' as const,
                                                    },
                                                    title: {
                                                        display: true,
                                                        text: item.nome,
                                                    },
                                                },
                                            }}

                                        />
                                    </div>
                                )}

                                {item.tipo === 'linha-mensal' && item.items.length > 0 && item.items.filter((f: any) => somaMeses(f.constanciaHorizontal) > 0).length > 0 && (
                                    <div className="col-md-4 mt-6">
                                        <Line options={{
                                            responsive: true,
                                            plugins: {
                                                legend: {
                                                    position: 'top' as const,
                                                },
                                                title: {
                                                    display: true,
                                                    text: item.nome,
                                                },
                                            },
                                        }} data={{
                                            labels: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                                            datasets: item.items.map((item2: any) => {
                                                return {
                                                    label: item2.nome,
                                                    data: [Math.abs(item2.constanciaHorizontal.janeiro), Math.abs(item2.constanciaHorizontal.fevereiro), Math.abs(item2.constanciaHorizontal.marco), Math.abs(item2.constanciaHorizontal.abril), Math.abs(item2.constanciaHorizontal.maio), Math.abs(item2.constanciaHorizontal.junho), Math.abs(item2.constanciaHorizontal.julho), Math.abs(item2.constanciaHorizontal.agosto), Math.abs(item2.constanciaHorizontal.setembro), Math.abs(item2.constanciaHorizontal.outubro), Math.abs(item2.constanciaHorizontal.novembro), Math.abs(item2.constanciaHorizontal.dezembro)],
                                                    borderColor: item2.color,
                                                    backgroundColor: item2.color
                                                }
                                            })
                                        }} />
                                    </div>
                                )}

                                {item.tipo === 'linha-mensal-porcentagem' && item.items.length > 0 && item.items.filter((f: any) => somaMeses(f.constanciaHorizontal) > 0).length > 0 && (
                                    <div className="col-md-4 mt-6">
                                        <Line options={{
                                            responsive: true,
                                            plugins: {
                                                legend: {
                                                    position: 'top' as const,
                                                },
                                                title: {
                                                    display: true,
                                                    text: item.nome,
                                                },
                                            },
                                        }} data={{
                                            labels: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                                            datasets: [{
                                                label: '%',
                                                data: [((Math.abs(item.items[1].constanciaHorizontal.janeiro) / Math.abs(item.items[0].constanciaHorizontal.janeiro)) * 100).toFixed(2), ((Math.abs(item.items[1].constanciaHorizontal.fevereiro) / Math.abs(item.items[0].constanciaHorizontal.fevereiro)) * 100).toFixed(2), ((Math.abs(item.items[1].constanciaHorizontal.marco) / Math.abs(item.items[0].constanciaHorizontal.marco)) * 100).toFixed(2), ((Math.abs(item.items[1].constanciaHorizontal.abril) / Math.abs(item.items[0].constanciaHorizontal.abril)) * 100).toFixed(2), ((Math.abs(item.items[1].constanciaHorizontal.maio) / Math.abs(item.items[0].constanciaHorizontal.maio)) * 100).toFixed(2), ((Math.abs(item.items[1].constanciaHorizontal.junho) / Math.abs(item.items[0].constanciaHorizontal.junho)) * 100).toFixed(2), ((Math.abs(item.items[1].constanciaHorizontal.julho) / Math.abs(item.items[0].constanciaHorizontal.julho)) * 100).toFixed(2), ((Math.abs(item.items[1].constanciaHorizontal.agosto) / Math.abs(item.items[0].constanciaHorizontal.agosto)) * 100).toFixed(2), ((Math.abs(item.items[1].constanciaHorizontal.setembro) / Math.abs(item.items[0].constanciaHorizontal.setembro)) * 100).toFixed(2), ((Math.abs(item.items[1].constanciaHorizontal.outubro) / Math.abs(item.items[0].constanciaHorizontal.outubro)) * 100).toFixed(2), ((Math.abs(item.items[1].constanciaHorizontal.novembro) / Math.abs(item.items[0].constanciaHorizontal.novembro)) * 100).toFixed(2), ((Math.abs(item.items[1].constanciaHorizontal.dezembro) / Math.abs(item.items[0].constanciaHorizontal.dezembro)) * 100).toFixed(2)],
                                                borderColor: item.items[1].color,
                                                backgroundColor: item.items[1].color
                                            }]
                                        }} />
                                        {console.log(item.items, Math.abs(item.items[0].janeiro))}
                                    </div>
                                )}

                                {item.tipo === 'barra' && item.items.length > 0 && item.items.filter((f: any) => somaMeses(f.constanciaHorizontal) > 0).length > 0 && (
                                    <div className="col-md-4 mt-6">
                                        <Bar
                                            options={{
                                                responsive: true,
                                                plugins: {
                                                    legend: {
                                                        position: 'top' as const,
                                                    },
                                                    title: {
                                                        display: true,
                                                        text: item.nome,
                                                    },
                                                },
                                            }}

                                            data={{
                                                labels: item.items.map((item2: any) => item2.nome),
                                                datasets: item.items.map((item2: any) => {
                                                    return {
                                                        label: item2.nome,
                                                        data: [somaMeses(item2.constanciaHorizontal)],
                                                        backgroundColor: item2.color,
                                                        borderColor: item2.color,
                                                        borderWidth: 1,
                                                    }
                                                }),
                                            }}

                                        />
                                    </div>
                                )}

                                {item.tipo === 'barra-horizontal-mensal' && item.items.length > 0 && item.items.filter((f: any) => somaMeses(f.constanciaHorizontal) > 0).length > 0 && (
                                    <div className="col-md-4 mt-6">
                                        <Bar
                                            options={{
                                                indexAxis: 'y' as const,
                                                elements: {
                                                    bar: {
                                                        borderWidth: 2,
                                                    },
                                                },
                                                responsive: true,
                                                plugins: {
                                                    legend: {
                                                        position: 'right' as const,
                                                    },
                                                    title: {
                                                        display: true,
                                                        text: item.nome,
                                                    },
                                                }
                                            }}

                                            data={{
                                                labels: ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
                                                datasets: [
                                                    {
                                                        label: 'R$',
                                                        data: [Math.abs(item.items[0].constanciaHorizontal.janeiro), Math.abs(item.items[0].constanciaHorizontal.fevereiro), Math.abs(item.items[0].constanciaHorizontal.marco), Math.abs(item.items[0].constanciaHorizontal.abril), Math.abs(item.items[0].constanciaHorizontal.maio), Math.abs(item.items[0].constanciaHorizontal.junho), Math.abs(item.items[0].constanciaHorizontal.julho), Math.abs(item.items[0].constanciaHorizontal.agosto), Math.abs(item.items[0].constanciaHorizontal.setembro), Math.abs(item.items[0].constanciaHorizontal.outubro), Math.abs(item.items[0].constanciaHorizontal.novembro)],
                                                        borderColor: item.items[0].color,
                                                        backgroundColor: item.items[0].color,
                                                    },
                                                ]
                                            }}

                                        />
                                    </div>
                                )}

                                {item.tipo === 'barra-horizontal' && item.items.length > 0 && (
                                    <div className="col-md-4 mt-6">
                                        <Bar
                                            options={{
                                                indexAxis: 'y' as const,
                                                elements: {
                                                    bar: {
                                                        borderWidth: 2,
                                                    },
                                                },
                                                responsive: true,
                                                plugins: {
                                                    legend: {
                                                        position: 'right' as const,
                                                    },
                                                    title: {
                                                        display: true,
                                                        text: item.nome,
                                                    },
                                                }
                                            }}

                                            data={{
                                                labels: item.items.filter((f: any) => somaMeses(f.constanciaHorizontal) > 0).map((item2: any) => item2.nome),
                                                datasets: [
                                                    {
                                                        data: item.items.filter((f: any) => somaMeses(f.constanciaHorizontal) > 0).map((item2: any) => somaMeses(item2.constanciaHorizontal)),
                                                        backgroundColor: item.items.filter((f: any) => somaMeses(f.constanciaHorizontal) > 0).map((item2: any) => item2.color),
                                                        borderColor: item.items.filter((f: any) => somaMeses(f.constanciaHorizontal) > 0).map((item2: any) => item2.color),
                                                        borderWidth: 1,
                                                    },
                                                ],
                                            }}

                                        />
                                    </div>
                                )}

                                {item.tipo === 'pizza' && item.items.length > 0 && (
                                    <div className="col-md-4 mt-6">
                                        <Doughnut
                                            width={100}
                                            height={200}
                                            options={{
                                                responsive: true,
                                                maintainAspectRatio: false,
                                                plugins: {
                                                    legend: {
                                                        position: 'top' as const,
                                                    },
                                                    title: {
                                                        display: true,
                                                        text: item.nome,
                                                    },
                                                },
                                            }} data={{
                                                labels: item.items.filter((f: any) => somaMeses(f.constanciaHorizontal) > 0).map((item2: any) => item2.nome),
                                                datasets: [
                                                    {
                                                        data: item.items.filter((f: any) => somaMeses(f.constanciaHorizontal) > 0).map((item2: any) => somaMeses(item2.constanciaHorizontal)),
                                                        backgroundColor: item.items.filter((f: any) => somaMeses(f.constanciaHorizontal) > 0).map((item2: any) => item2.color),
                                                        borderColor: item.items.filter((f: any) => somaMeses(f.constanciaHorizontal) > 0).map((item2: any) => item2.color),
                                                        borderWidth: 1,
                                                    },
                                                ],
                                            }} />
                                    </div>
                                )}
                            </>
                        ))}
                    </div>
                </div>
            </div>
        </Modal>
    )
}

export default ModalDashboardVertical